import React, { useState, useEffect, useRef } from "react";
import "./Faq.scss";

const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const contentRefs = useRef([]);

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  useEffect(() => {
    contentRefs.current.forEach((content, i) => {
      if (content) {
        if (i === activeIndex) {
          content.style.maxHeight = `${content.scrollHeight}px`; // Expand to full height
        } else {
          content.style.maxHeight = "0"; // Collapse smoothly
        }
      }
    });
  }, [activeIndex]);

  const accordionData = [
    {
      question: "What is Personal Injury Claim?",
      answer:
        "A personal injury claim is a legal case against another party if you have been injured as a result of their malpractice or negligence. This is the process of claiming compensation for your losses, including physical and financial damages.",
    },
    {
      question: "How much compensation can I claim?",
      answer:
        "The amount you can claim depends on the severity of your injury and the impact on your life. To determine compensation, your solicitor will consider two factors: general damages and special damages.",
    },
    {
      question: "What's the process?",
      answer:
        "To start a personal injury claim, simply fill out our quick form and one of our experts will be in touch. They'll discuss your case and determine whether we can connect you to one of our partnered solicitors.",
    },
    {
      question: "Why use “Should I Claim Compensation”?",
      answer:
        "We're the experts! We're very well connected and if we identify a potential claim we will match you with a solicitor we work with. By having a nationwide network of experienced legal professionals we're able to match you with a solicitor to fit your needs. ",
    },
    {
      question: "What is the fee for your service?",
      answer:
        "All of the solicitors we work with work on a *no-win, no-fee basis to ensure that everyone who makes a claim has access to justice without having to worry about any upfront costs, especially if a claim is not successful.",
      description:
        "*Typically, customers pay 25% including VAT of the compensation amount that is recovered by our third-party law firms, although this is subject to your individual circumstances and the actual fee may be more or less than this. Termination fees may apply if you do not keep to the terms of the agreement.",
    },
  ];

  return (
    <section className="faq">
      <div className="container1286">
        <div className="faq-accordion">
          <div className="faq-accordion-details">
            <h2>
              {" "}
              Frequently Asked <strong>Questions</strong>{" "}
            </h2>
            <p>Need more info? look no further.</p>
          </div>
          {accordionData.map((item, index) => (
            <div
              className={`accordion-item ${
                activeIndex === index ? "active" : ""
              }`}
              key={index}
            >
              <div
                className="accordion-label"
                onClick={() => toggleAccordion(index)}
              >
                <span className="accordion-question">{item.question}</span>
                <span className="icon">
                  <div className="plus-icon">
                    <div className="bar-one"></div>
                    <div className="bar-two"></div>
                  </div>
                </span>
              </div>
              <div
                className="accordion-content"
                ref={(el) => (contentRefs.current[index] = el)}
                style={{
                  overflow: "hidden",
                  transition: "max-height 0.5s ease",
                }}
              >
                <p>{item.answer}</p>
                <br />
                {accordionData.length - 1 === index && (
                  <div>
                    <p className="tnc">
                      <i>{item.description}</i>
                    </p>
                    <br />
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Faq;
